import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import {
    ToggleButton,
    Flex,
} from '@zillow/constellation';

import { GA_EVENTS_TENANTS } from 'app/shared/constants/AnalyticsConstants';
import { CHILD_ROUTE } from 'app/shared/containers/TenantsPage/constants';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import { StyledToggleButtonGroup } from './StyledComponents';

const { FIND_TENANTS_TOGGLE, MANAGE_TENANTS_TOGGLE } = GA_EVENTS_TENANTS;
const { FIND_TENANTS, MANAGE_TENANTS } = CHILD_ROUTE;
const toggles = [
    {
        route: FIND_TENANTS,
        text: 'Find tenants',
    },
    {
        route: MANAGE_TENANTS,
        text: 'Manage tenants',
    },
];

const propTypes = {
    currentSection: PropTypes.string.isRequired,
    match: PropTypes.object.isRequired,
    setCurrentSection: PropTypes.func.isRequired,
};

const ManageFindTenantsToggle = ({
    currentSection,
    match,
    setCurrentSection,
}) => {
    const dispatch = useDispatch();

    const triggerGAEvent = (targetPath) => {
        switch (targetPath) {
            case FIND_TENANTS:
                dispatch(analyticsUtils.track.GAEventV2(FIND_TENANTS_TOGGLE));
                break;
            case MANAGE_TENANTS:
                dispatch(analyticsUtils.track.GAEventV2(MANAGE_TENANTS_TOGGLE));
                break;
            default:
                console.warn('No case for', targetPath);
                break;
        }
    };

    const handleToggleClick = (route) => {
        // remove trailing slash
        match.url = match.url.replace(/\/$/, '');
        const path = `${match.url.replace(currentSection, '')}${route}`;

        setCurrentSection(route);
        triggerGAEvent(route);

        window.router.transitionTo(path);
    };

    return (
        <Flex display="flex" justifyContent="center">
            <StyledToggleButtonGroup
                aria-label="find and manage tenants toggle"
                defaultValue={currentSection}
                onChange={handleToggleClick}
            >
                {toggles.map(({ route, text }) => (
                    <ToggleButton
                        key={route}
                        controlId={route}
                        value={route}
                    >
                        {text}
                    </ToggleButton>
                ))}
            </StyledToggleButtonGroup>
        </Flex>
    );
};

ManageFindTenantsToggle.propTypes = propTypes;

export default ManageFindTenantsToggle;
